import React, {useRef, useState, useEffect}                 from "react";
import {Button}                                             from "@sirius/ui-lib/src/blocks/Controls";
import {UiSchemaEntry, DataCellType, ColumnCellType}        from "../@types";
import                                                           "./edit.less";

const DataCell:React.FC<DataCellType> = ({row, RowEditElement, wrapperRef, closeEditOnScroll}) => {
    const [showEditPopup, setShowEditPopup] = useState<boolean>(false);
    const button = useRef<HTMLButtonElement>(null);
    const toggleEditPopup = (e: React.MouseEvent ) => {
        setTimeout(
            ()=>{
                setShowEditPopup(!showEditPopup)
            }
        )
    }
    const close = () => {setShowEditPopup(false)}

    useEffect(() => {
        if (closeEditOnScroll) {
            wrapperRef?.current.addEventListener('scroll', close);
            window.addEventListener('scroll', close);
        }

        return () => {
            if (closeEditOnScroll) {
                wrapperRef?.current?.removeEventListener('scroll', close)
                window.removeEventListener('scroll', close);
            }
        };
    }, []);

    return  <>
                <Button
                    buttonRef = {button}
                    onAction  = {toggleEditPopup}
                    active    = {showEditPopup}
                    size      = "s"
                    icon      = "more_vert"
                    mode      = "secondary"
                />
                {
                    <RowEditElement
                        row     = { row }
                        target  = { showEditPopup && button.current }
                        close   = { close }
                    />
                }
            </>
    ;
}

const ColumnCell:React.FC<ColumnCellType> = () => null;

const edit: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {edit}
